import { css } from '@emotion/react';

export const containerStyles = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: var(--spacing-4);
  background-color: var(--color-yellow-100);
  border: 1px solid var(--color-yellow-300);
  border-radius: 8px;
  max-width: 320px;
  margin: 0 auto;
`;

export const iconStyles = css`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: var(--color-yellow-200);
  color: var(--color-yellow-700);
`;

export const statusStyles = css`
  font-size: 0.875rem;
  color: var(--text-secondary);
`;
